import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Home } from 'lucide-react';
import useDocumentTitle from '../hooks/useDocumentTitle';

const NotFound = () => {
  useDocumentTitle('Page not found');

  return (
    <section className="min-h-[80vh] flex items-center justify-center bg-bg-canvas mesh-sky-bg pt-24">
      <div className="text-center px-6 py-12">
        <div className="font-display font-extrabold text-[120px] lg:text-[180px] text-gradient-sky leading-none tracking-tight">
          404
        </div>
        <h1 className="font-display font-bold text-3xl lg:text-4xl text-text-primary mb-3 mt-4">
          Page not found
        </h1>
        <p className="text-text-secondary max-w-lg mx-auto mb-8">
          The page you're looking for doesn't exist, or has moved. Try one of the links below.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link to="/" className="btn-primary">
            <Home size={16} />
            Back to Home
          </Link>
          <button onClick={() => window.history.back()} className="btn-secondary">
            <ArrowLeft size={16} />
            Go Back
          </button>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
